import {
  get,
} from '@/utils/lodash';

export default {
  isLoggedIn(state) {
    return get(state, 'user.id') != null;
  },
  getUserDetails: (state) => state.userDetails,
};
